// @flow
/* eslint-disable max-len,react/require-default-props */

import * as React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: 'none',
        stroke: '#999ea7',
        strokeLinejoin: 'round',
        strokeWidth: 1.5,
    },
    second: {
        fill: 'none',
        stroke: '#999ea7',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
        strokeWidth: 1.00959492614297,
    },
    third: {
        fill: '#999ea7',
    },
};

const xml = `
        <svg xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 5 }} viewBox="0 0 26.16 25.81" width={25} height={25}>
            <title>save_</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path
                        d="M25.41,6.85v16.8A1.42,1.42,0,0,1,24,25.06H2.18A1.42,1.42,0,0,1,.75,23.65V2.16A1.42,1.42,0,0,1,2.18.75h17Z"
                        style={styles.first}
                    />
                    <path d="M14.85,8H4.73A1.17,1.17,0,0,1,3.56,6.78v-6s0,0,0,0H16s0,0,0,0v6A1.17,1.17,0,0,1,14.85,8Z" style={styles.second} />
                    <path d="M20.24,12.65H5.92a1.43,1.43,0,0,0-1.43,1.43v11H21.67v-11A1.43,1.43,0,0,0,20.24,12.65Z" style={styles.second} />
                    <rect x="10.61" y="3.14" width="2.99" height="2.39" style={styles.third} />
                </g>
            </g>
        </svg>
`;

const DisabledSaveIcon = () => (
    Platform.OS === 'web' ? (
        // eslint-disable-next-line react-native/no-inline-styles
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.16 25.81" width={25} height={25} style={{ marginRight: 5 }}>
            <title>save_</title>
            <g id="Layer_2">
                <g id="Layer_1-2">
                    <path
                        d="M25.41,6.85v16.8A1.42,1.42,0,0,1,24,25.06H2.18A1.42,1.42,0,0,1,.75,23.65V2.16A1.42,1.42,0,0,1,2.18.75h17Z"
                        style={styles.first}
                    />
                    <path d="M14.85,8H4.73A1.17,1.17,0,0,1,3.56,6.78v-6s0,0,0,0H16s0,0,0,0v6A1.17,1.17,0,0,1,14.85,8Z" style={styles.second} />
                    <path d="M20.24,12.65H5.92a1.43,1.43,0,0,0-1.43,1.43v11H21.67v-11A1.43,1.43,0,0,0,20.24,12.65Z" style={styles.second} />
                    <rect x="10.61" y="3.14" width="2.99" height="2.39" style={styles.third} />
                </g>
            </g>
        </svg>
    ) : (<SvgXml xml={xml} />)
);

export default DisabledSaveIcon;
